import { ColDef, ColGroupDef } from "ag-grid-community/dist/lib/entities/colDef";
import { CsvExportParams, ExcelExportParams } from "ag-grid-enterprise";
import { ManagedCatalogueStockView } from "models/dbModels/nanagedCatalogues/ManagedCatalogueStock";
import { ManagedStockPde } from "../models/dbModels/managedStock/ManagedStockPde";
import { ManagedStockApn } from "../models/dbModels/managedStock/ManagedStockApn";

export function getCatalogueStocksConfig(user: any, apns: ManagedStockApn[], pdes: ManagedStockPde[], searchApn: boolean, searchPde: boolean): (ColDef<ManagedCatalogueStockView> | ColGroupDef<ManagedCatalogueStockView>)[] | null {
        
    return [
        {
            headerCheckboxSelectionFilteredOnly: true,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 45,
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
        },
        {
            headerName: "Name",
            field: "name",
            sort: "asc", 
            sortable: true,
            flex: 1,
            minWidth: 400
        },
        {
            headerName: "Apns",
            flex: 1,
            minWidth: 200,
            hide: true,
            valueGetter: (params)=>{
                if(apns == undefined)
                    return;
                const msApns = apns.filter(x => x.managedStockId == params.data?.managedStockId)
                    .map(c=>c.apn);

                return msApns.toString();
            },
            getQuickFilterText: (params) => {
                if (searchApn == false)
                    return '';
                return params.value;
            }
        },
        {
            headerName: "Pdes",            
            flex: 1,
            minWidth: 200,
            hide: true,
            valueGetter: (params)=>{
                if(pdes == undefined)
                    return;
                const msPdes = pdes.filter(x => x.managedStockId == params.data?.managedStockId)
                    .map(c=>c.pde);

                return msPdes.toString();
            },
            getQuickFilterText: (params) => {
                if (searchPde == false)
                    return '';
                return params.value;
            }
        },
        {
            headerName: "Promo Type",
            field: 'type',
            flex: 1,
            editable: user.permissions.promotions.canUpdate,
            minWidth: 190,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
                values: ["Buy X For $", "Buy X or more get % off"],
            },
            valueGetter: (params) => {
                if(params.data?.type == 0)
                    return "Buy X for $";
                else
                    return "Buy X or more get % off";
            },
            valueSetter: (params) => {
                if(params.newValue.includes("$")){
                    params.data.type = 0;
                    return true;
                }              
                params.data.type = 1;
                return true;
            },
        },
        {
            headerName: "X",
            flex: 1,
            minWidth: 70,
            editable: user.permissions.promotions.canUpdate,
            field: "quantity",
            cellEditor: 'agNumberCellEditor',
            cellEditorParams: {
                min: 0,
                step: 1,
                showStepperButtons: true
            }
        },
        {
            headerName: "Value",
            flex: 1,
            minWidth: 120,
            editable: user.permissions.promotions.canUpdate,
            field: "value",
            cellClass: 'cursor-text moneyField',
            valueSetter: (params) => {
				params.data.value = isNaN(params.newValue) ?  0.0000 : params.newValue;
				return true;
            },
            valueGetter: (params) => {
                if(params.data?.value == 0)
                    return null;
                else
                    return params.data?.value;
            },
            cellRendererSelector: (params) => {
                if(params.data?.type == 0)
                    return { component: "editablePriceCellRenderer" }
                else
                    return { component: "editablePercentCellRenderer"}
            },
            cellEditorSelector: (params) => {
                if(params.data?.type == 0)
                    return { component: "moneyCellEditor" }
                else
                    return { component: "percentCellEditor"}
            }
        },
    ]
}

export function getCatalogStockCsvDataFormatter(catalogName: string): CsvExportParams{
    return {
        fileName: catalogName +"_" + new Date().toLocaleDateString('en-AU', {
            day : 'numeric',
            month : 'short',
            year : 'numeric',
            hour : '2-digit',
            minute : '2-digit'
        }).split(' ').join('-').replace(',', '') +".csv",

        processCellCallback: (cell) => {
              return cell.value;
        },
        columnKeys: ["name", "type", "quantity","value"]
    }
}
    


export function getCatalogStockDataFormatter(): ExcelExportParams {
    return {
        processCellCallback: (cell) => {
              return cell.value;
        },
        columnKeys: ["name", "type", "quantity","value"],
        sheetName: "Catelogue Stock"
    }
}

// Export settings for Excel export
export function getCatalogStockCoverPage(filterDetails: string): ExcelExportParams {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    };
    const formattedDate = now.toLocaleString('en-US', options);
    return {       
      prependContent: [
          {
            cells: [
              { data: { type: "String", value: "Details" }, styleId: "header" }
            ]
          },
          {
            cells: [
              { data: { type: "String", value: "Name:" } },
              { data: { type: "String", value: "Catalogue" } }
            ]
          },         
          {
            cells: [
              { data: { type: "String", value: "Filter Details:" } },
              { data: { type: "String", value: filterDetails } }
            ]
          },
          {
            cells: [
              { data: { type: "String", value: "Date Generated:" } },
              { data: { type: "String", value: formattedDate  } }
            ]
          }
        ],
        processHeaderCallback: () => "",
        processCellCallback: () => "",
        sheetName: "Details",
    }!;
  }